import {
  Box,
  HStack,
  TabList,
  TabPanel,
  TabPanels,
  Tabs,
} from '@chakra-ui/react';
import {
  Heading,
  TextInput,
  useCQMediaQuery,
  useTabStorage,
} from '@laxmimanogna/code-quick-components';
import React, { useContext, useEffect, useState } from 'react';
import CQContainer from '../../components/layout/CQContainer';
import { FONT_FAMILY } from '../../constants/Theme';
import MyAuditProvider, {
  MyAuditContext,
} from '../../providers/MyAuditProvider';
import RecentAudits from './components/RecentAudits';
import { withProvider } from '../../hoc/withProvider';
import Archived from './components/tables/Archived';
import MyAudits from './components/tables/MyAudits';
import Rebuttals from './components/tables/Rebuttals';
import NewUploads from './components/tables/NewUploads';
import Urgent from './components/tables/Urgent';
import { SearchIcon } from '@chakra-ui/icons';
import AppColors from '../../constants/AppColors';
import { UrgentIcon } from '../../constants/IconData';
import { CustomTab } from '../../components/CustomTab';

const DashboardContainer = props => {
  // states
  const [onSearchText, setSearchText] = useState('');
  const tabStorage = useTabStorage();
  const [selectedTab, setSelectedTab] = useState(tabStorage.getTab() || 0);

  useEffect(() => {tabStorage.setTab(selectedTab)}, [selectedTab]);

  // constData
  const myAuditContext = useContext(MyAuditContext);
  const {
    getRecentAudits,
    handleApplyFilter,
    filterParams,
    auditUrgentListCount,
  } = myAuditContext;

  const auditorPortalTabs = [
    {
      title: 'NEW UPLOADS',
      header: 'New Uploads',
      component: NewUploads,
    },
    {
      title: 'MY AUDITS',
      header: 'My Audits',
      component: MyAudits,
    },
    {
      title: 'ARCHIVED',
      header: 'Archived',
      component: Archived,
    },
    {
      title: 'REBUTTALS',
      header: 'Rebuttals',
      component: Rebuttals,
    },
    {
      title: 'URGENT',
      header: 'Urgent',
      component: Urgent,
    },
  ];

  // life-cycle hooks
  useEffect(() => {
    getRecentAudits();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const onSearchAction = () => {
    handleApplyFilter({ ...filterParams, searchText: onSearchText });
  };
  const onFilterChange = e => {
    if (e) {
      myAuditContext.getMyAuditUpload.setParams({ page: 1 });
      myAuditContext.getAuditNewUploads.setParams({ page: 1 });
      myAuditContext.getAuditArchived.setParams({ page: 1 });
      myAuditContext.getAuditRebuttals.setParams({ page: 1 });
      myAuditContext.getAuditUrgent.setParams({ page: 1 });
      setSearchText(e.target.value);
    } else {
      setSearchText('');
    }
  };

  // other hooks

  const marginHorizontal = useCQMediaQuery({
    lg: '12%',
    md: '6%',
    sm: '2%',
  });

  return (
    <Box>
      <Box
        py={5}
        height={280}
        bg={'white'}
        overflow={'hidden'}
        px={marginHorizontal}
      >
        <Heading
          fontSize={'24px'}
          fontFamily={FONT_FAMILY.baiJamurjee}
          fontWeight="bold"
          py={3}
        >
          Recent Audits
        </Heading>
        <RecentAudits />
      </Box>
      <CQContainer py={30} mx={marginHorizontal}>
        <Heading my={5} as="h5" fontSize="24px">
          Audit Uploads
        </Heading>
        <Box bg="white" p={4} w="100%" style={{ borderRadius: '12px' }}>
          <Tabs
            fontFamily={FONT_FAMILY.baiJamurjee}
            onChange={setSelectedTab}
            index={selectedTab}
          >
            <TabList>
              <HStack w={'100%'} justifyContent={'space-between'}>
                <HStack spacing={4} px={4}>
                  {auditorPortalTabs.map((apt, i) => {
                    return (
                      <Box position={'relative'}>
                        <CustomTab
                          key={`assigned-audit-tab-${i}`}
                          pb={4}
                          color={AppColors.secondary}
                          fontFamily={FONT_FAMILY.baiJamurjee}
                        >
                          {apt.title}
                          {apt.title === 'URGENT' &&
                          auditUrgentListCount > 0 ? (
                            <UrgentIcon
                              style={{
                                position: 'absolute',
                                left: 90,
                                top: 5,
                              }}
                            />
                          ) : null}
                        </CustomTab>
                      </Box>
                    );
                  })}
                </HStack>
                <Box>
                  <TextInput
                    borderRadius={'md'}
                    value={onSearchText}
                    onChange={e => onFilterChange(e)}
                    onKeyDown={e => {
                      if (e.keyCode === 13) {
                        onSearchAction();
                      }
                    }}
                    mb="2"
                    rightIconProps={{ zIndex: 0 }}
                    placeholder="Search"
                    mr={1}
                    rightIcon={<SearchIcon onClick={onSearchAction} />}
                    height={'50px'}
                  />
                </Box>
              </HStack>
            </TabList>

            <TabPanels>
              {auditorPortalTabs.map((apt, i) => {
                return (
                  <TabPanel p={0} key={`assigned-audit-panel-${i}`}>
                    <apt.component />
                  </TabPanel>
                );
              })}
            </TabPanels>
          </Tabs>
        </Box>
      </CQContainer>
    </Box>
  );
};

export default withProvider(MyAuditProvider, DashboardContainer);
